import PropTypes from 'prop-types';
import React from 'react';

export class Badge extends React.Component {
  UNSAFE_componentWillMount() {
    if (this.props.badgeProperties !== undefined && this.props.badgeProperties.dispatchMethod !== undefined) {
      this.props.badgeProperties.dispatchMethod();
    }
  }


  renderBadgeNumber() {
    if (this.props.badgeProperties === undefined
    || this.props.badgeProperties.stateCounter === undefined) {
      return null;
    }
    if (this.props.badgeProperties.stateCounter > 0) {
      return this.props.badgeProperties.stateCounter;
    }
    return null;
  }

  render() {
    const badgeNumber = this.renderBadgeNumber();
    if (badgeNumber) {
      return (
        <div className={'menu-tab-badge' + (this.props.className ? ' ' + this.props.className : '') }>
          <span className="badge tab-badge">{ this.renderBadgeNumber() }</span>
        </div>
      );
    }
    return null;
  }
}
Badge.propTypes = {
  badgeProperties: PropTypes.object,
  className: PropTypes.string,
};
